import axios from 'axios'
import { GetAxiosAuthConfig } from '../mixins/axiosAuth'


export const GetTags = {
    // Returns a list of tag objects.
    mixins: [GetAxiosAuthConfig],
    data() {
        return {
            tagnames: [],
            tagnames_loading: false,
        }
    },
    created() {
        this.GetTags()
    },
    methods: {
        GetTags() {
            // set as loading
            this.tagnames_loading = true
            
            // This gets tags from the database list (which are always distinct)
            let resturl = window.location.origin + '/api/tagnames/'
            
            axios.get(resturl, axios_auth_config)
                .then(response => {
                    // get results
                    this.tagnames = response.data.tagnames

                    // done loading
                    this.tagnames_loading = false
                })
                .catch(error => console.log(error))
        }
    },
}
